import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  Layout,
  Button,
  Row,
  Col,
  Table,
  Divider,
  Dropdown,
  Modal,
  MenuProps,
  Popover,
  Image,
  DatePicker,
  Select,
} from "antd";
// import type { MenuProps } from "antd";
import {
  MoreOutlined,
  PrinterOutlined,
  EditOutlined,
  DeleteOutlined,
  FilePdfOutlined,
  ReloadOutlined,
  FolderOpenOutlined,
  DollarOutlined,
  CheckOutlined,
  AlertOutlined,
  ContainerFilled,
  FilterOutlined,
} from "@ant-design/icons";
import {
  deleteInvoiceService,
  getBuyersService,
  getInvoicePDF,
  getInvoicesService,
  getMaterialService,
  getMetalsService,
  getSaleService,
} from "./InvoicesPageService";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import "./InvoicesPage.css";
import Loader from "../../components/Loader/Loader";
import printJS from "print-js";
import { removeTokenFromCookies } from "../../utils/cookies";
import Copyright from "../../components/Copyright/Copyright";
import Cookies from "universal-cookie";
import dayjs from "dayjs";
import moment from "moment";

const { RangePicker } = DatePicker;
const { Content } = Layout;

export interface InvoicesPageProps {}

const InvoicesPage = (props: InvoicesPageProps) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [loading, setLoading] = useState(false);
  const [invoicesList, setInvoicesList] = useState([]) as any;
  const [invoiceDetailsTable, setInvoiceDetailsTable] = useState([]) as any;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [invoiceToDelete, setInvoiceToDelete] = useState({}) as any;
  const [isPDFModalOpen, setIsPDFModalOpen] = useState(false);
  const [printInvoiceData, setPrintInvoiceData] = useState(null) as any;
  const [buyers, setBuyers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalInvoices, setTotalInvoices] = useState(0);
  const [invoiceDetailsTableData, setInvoiceDetailsTableData] = useState([]) as any;
  const [metals, setMetals] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [buyersSelectedOptions, setBuyersSelectedOptions] = useState("");
  const [dateRangeFilter, setDateRangeFilter] = useState([null, null]) as any;
  const [dateRangeValue, setDateRangeValue] = useState([null, null]) as any;
  const [buyersOptions, setBuyersOptions] = useState([]) as any;
  const [isFilteredData, setIsFilteredData] = useState(false);
  let navigate = useNavigate();
  const cookies = new Cookies();
  const currOffice = cookies.get("CURR_OFFICE");
  const invoiceColumns = [
    {
      title: "Item Number",
      key: "itemNumber",
      align: "center",
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: "Sale Date",
      key: "date",
      align: "center",
      render: (record: any) => new Date(record.saleCreatedTimestamp).toLocaleDateString("en-GB"),
    },
    {
      title: "Sale Time",
      key: "time",
      align: "center",
      render: (record: any) =>
        new Date(record.saleCreatedTimestamp).toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        }),
    },
    {
      title: "Invoice Number",
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
    },
    {
      title: "Buyer",
      key: "buyer",
      render: (record: any) => getBuyerDisplayName(record.buyerID),
    },
    {
      title: <span style={{ paddingRight: "0px" }}>Total Net Weight (kg)</span>,
      key: "totalNetWeight",
      align: "center",
      render: (record: any) =>
        record.totalNetWeight ? (
          <strong style={{ marginRight: "10px" }}>{Number(record.totalNetWeight).toFixed(1)}</strong>
        ) : (
          ""
        ),
    },
    {
      title: <span style={{ paddingRight: "0px" }}>Materials Info</span>,
      key: "totalNumMaterials",
      align: "center",
      render: (record: any) => (record.totalNumMaterials ? `${record.totalNumMaterials} materials` : ""),
    },
    {
      title: "Transaction Type",
      key: "transactionType",
      align: "center",
      render: (record: any) => {
        return record.smallTransaction ? (
          "Small"
        ) : (
          <>
            <ContainerFilled style={{ marginRight: "5px", color: "#283555" }} />
            Invoice
          </>
        );
      },
    },
    Table.EXPAND_COLUMN,
    {
      title: <span style={{ paddingRight: "0px" }}>Total Invoice Amount (RM)</span>,
      dataIndex: "totalAmount",
      key: "totalAmount",
      align: "right",
      render: (totalAmount: string) => (
        <strong style={{ marginRight: "10px" }}>{Number(totalAmount).toFixed(2)}</strong>
      ),
    },
    {
      title: "Invoice Completed",
      dataIndex: "completed",
      align: "center" as const,
      render: (record: any) =>
        record ? (
          <>
            <CheckOutlined style={{ color: "green", marginRight: "5px" }} /> Yes
          </>
        ) : (
          <>
            <AlertOutlined style={{ color: "orange", marginRight: "5px" }} />
            No
          </>
        ),
    },
    {
      title: "Payment Method",
      dataIndex: "paymentMethod",
      key: "paymentMethod",
    },
    {
      title: "Print Invoice",
      key: "printInvoice",
      align: "center",
      render: (record: any) =>
        record.completed ? (
          <Button type="primary" size="small" onClick={() => printInvoice(record)} icon={<PrinterOutlined />}>
            Print Invoice
          </Button>
        ) : null,
    },
    {
      title: "Created Date",
      key: "date",
      align: "center",
      render: (record: any) => new Date(record.createdTimestamp).toLocaleDateString("en-GB"),
    },
    {
      title: "Created Time",
      key: "time",
      align: "center",
      render: (record: any) =>
        new Date(record.createdTimestamp).toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        }),
    },
    {
      title: "Options",
      key: "options",
      align: "center",
      render: (record: any) => {
        const userRole = cookies.get("USER_ROLE");
        let items: MenuProps["items"] = [];
        if (record.completed) items.push({ key: "print", label: "Print Invoice", icon: <PrinterOutlined /> });
        record.completed && isTimestampMoreThan2Hours(record.createdTimestamp)
          ? items.push({ key: "edit", label: "View Invoice", icon: <DollarOutlined /> })
          : items.push({ key: "edit", label: "Edit Invoice", icon: <EditOutlined /> });
        items.push({ key: "sale", label: "View Sale", icon: <FolderOpenOutlined /> });
        if (userRole === "admin")
          items.push({ key: "delete", label: "Delete Invoice", icon: <DeleteOutlined />, style: { color: "red" } });

        return (
          <Dropdown
            menu={{
              items,
              onClick: ({ key }) => {
                if (key === "edit") editInvoice(record);
                else if (key === "delete") openDeleteInvoiceModal(record);
                else if (key === "print") printInvoice(record);
                else if (key === "sale") viewSale(record.saleID);
              },
            }}
            trigger={["click"]}
          >
            <a onClick={(e) => e.preventDefault()}>
              <MoreOutlined style={{ fontSize: "24px" }} />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  const invoiceDetailsColumns = [
    {
      title: "Item Number",
      key: "itemNumber",
      align: "center" as const,
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: "Images",
      key: "index",
      render: (record: any) => (
        <>
          <Image
            height={50}
            width={50}
            src={record.scaleImageURL || record.imageURL}
            wrapperStyle={{ marginRight: "10px" }}
            preview={{
              toolbarRender: () => (
                <>
                  <h1 style={{ color: "#000000" }}>{record.displayName}</h1>
                  <h3 style={{ color: "#000000" }}>Raw Weight: {Number(record.rawWeight).toFixed(1)} kg</h3>
                  <h3 style={{ color: "#000000" }}>Net Weight: {Number(record.netWeight).toFixed(1)} kg</h3>
                </>
              ),
            }}
          />
          <Image
            height={50}
            width={50}
            src={record.materialImageURL}
            preview={{
              toolbarRender: () => (
                <>
                  <h1 style={{ color: "#000000" }}>{record.displayName}</h1>
                  <h3 style={{ color: "#000000" }}>Raw Weight: {Number(record.rawWeight).toFixed(1)} kg</h3>
                  <h3 style={{ color: "#000000" }}>Net Weight: {Number(record.netWeight).toFixed(1)} kg</h3>
                </>
              ),
            }}
          />
        </>
      ),
      align: "center" as const,
    },
    {
      title: "Material Name",
      key: "materialName",
      align: "left" as const,
      render: (record: any) => record.displayName,
    },
    {
      title: "Net Weight (kg)",
      key: "netWeight",
      align: "center" as const,
      render: (record: any) => Number(record.netWeight).toFixed(1),
    },
    {
      title: "Price (RM/kg)",
      key: "cashAmount",
      align: "right" as const,
      render: (record: any) => Number(record.price).toFixed(2),
    },
    {
      title: "Amount (RM)",
      key: "amount",
      align: "right" as const,
      render: (record: any) => Number(Number(record.price) * Number(record.netWeight)).toFixed(2),
    },
  ];

  useEffect(() => {
    navToSelectOffice();
    getBuyers();
    getMetals();
  }, []);

  useEffect(() => {
    getInvoices(currentPage, buyersSelectedOptions, dateRangeFilter);
  }, [currentPage]);

  const navToSelectOffice = () => {
    if (currOffice === "" || currOffice === undefined || currOffice === null) navigate("/");
  };

  const toggleSidebar = (collapsed: boolean) => {
    setSidebarCollapsed(collapsed);
  };

  const navToLogin = () => {
    navigate("/login");
  };

  const getInvoices = async (pageNumber: Number, buyersFilter: String, dateRangeFilter: String[]) => {
    try {
      setLoading(true);
      const filters = {
        buyers: buyersFilter,
        startDate: dateRangeFilter[0] === null || dateRangeFilter.length === 0 ? "" : dateRangeFilter[0],
        endDate: dateRangeFilter[1] === null || dateRangeFilter.length === 0 ? "" : dateRangeFilter[1],
      };
      const resInvoice = await getInvoicesService(currOffice, String(pageNumber), filters);
      console.log("resInvoice", resInvoice);
      setTotalPages(resInvoice.data.totalPages);
      setTotalInvoices(resInvoice.data.totalInvoices);
      const currInvoices: any[] = [];
      for (let invoice of resInvoice.data.invoices) {
        invoice.key = invoice.invoiceID;
        // const saleID = invoice.saleID;
        // const resSale = await getSale(saleID);
        // invoice.materialIDList = resSale?.data.materialIDList;
        currInvoices.push(invoice);
      }
      setInvoicesList([...currInvoices]);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getInvoices error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getSale = async (saleID: string) => {
    try {
      setLoading(true);
      const res = await getSaleService(currOffice, saleID);
      setLoading(false);
      return res.data;
    } catch (e: any) {
      setLoading(false);
      console.error("getSale error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getBuyers = async () => {
    try {
      setLoading(true);
      const res = await getBuyersService();
      const buyersData = currOffice === "pg" ? res.data.pgBuyers : currOffice === "bw" ? res.data.bwBuyers : [];
      setBuyers(buyersData);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getBuyers error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getMetals = async () => {
    try {
      setLoading(true);
      const res = await getMetalsService();
      setMetals(res.data);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getMetals error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getMaterial = async (materialID: string) => {
    try {
      setLoading(true);
      const res = await getMaterialService(materialID);
      setLoading(false);
      return res;
    } catch (e: any) {
      setLoading(false);
      console.error("getMaterial error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getBuyerDisplayName = (buyerID: any) => {
    const buyerInfo = buyers.find((buyer: any) => buyer.buyerID === buyerID);
    let buyerDisplayInfo = "";
    let popoverContent = <></>;
    if (
      buyerInfo !== undefined &&
      buyerInfo["companyName"] !== undefined &&
      buyerInfo["companyName"] !== "" &&
      buyerInfo["name"] !== undefined &&
      buyerInfo["name"] !== ""
    ) {
      buyerDisplayInfo = buyerInfo["companyName"] + " (" + buyerInfo["name"] + ")";
      popoverContent = (
        <div>
          <p>Name: {buyerInfo["name"]}</p>
          <p>Company: {buyerInfo["companyName"]}</p>
          {buyerInfo["identificationCardNumber"] !== "" && <p>IC Number: {buyerInfo["identificationCardNumber"]}</p>}
          {buyerInfo["passportNumber"] !== "" && <p>Passport Number: {buyerInfo["passportNumber"]}</p>}
        </div>
      );
    } else if (buyerInfo !== buyerInfo && buyerInfo["companyName"] !== undefined && buyerInfo["companyName"] !== "") {
      buyerDisplayInfo = buyerInfo["companyName"];
      popoverContent = (
        <div>
          <p>Company: {buyerInfo["companyName"]}</p>
          {buyerInfo["identificationCardNumber"] !== "" && <p>IC Number: {buyerInfo["identificationCardNumber"]}</p>}
          {buyerInfo["passportNumber"] !== "" && <p>Passport Number: {buyerInfo["passportNumber"]}</p>}
        </div>
      );
    } else if (buyerInfo !== undefined && buyerInfo["name"] !== undefined && buyerInfo["name"] !== "") {
      buyerDisplayInfo = buyerInfo["name"];
      popoverContent = (
        <div>
          <p>Name: {buyerInfo["name"]}</p>
          {buyerInfo["identificationCardNumber"] !== "" && <p>IC Number: {buyerInfo["identificationCardNumber"]}</p>}
          {buyerInfo["passportNumber"] !== "" && <p>Passport Number: {buyerInfo["passportNumber"]}</p>}
        </div>
      );
    }
    return <Popover content={popoverContent}>{buyerDisplayInfo}</Popover>;
  };

  const formatInvoiceBuyerFileName = (buyerID: string, invoiceNumber: string, invoiceID: string) => {
    const buyerInfo: any = buyers.find((buyer: any) => buyer.buyerID === buyerID);
    const buyerName = buyerInfo.companyName ? buyerInfo.companyName : buyerInfo.name;
    return `invoice_${buyerName}_${invoiceNumber}_${invoiceID}.pdf`.replaceAll(" ", "_");
  };

  const printInvoice = async (record: any) => {
    try {
      setLoading(true);
      const fileName = formatInvoiceBuyerFileName(record.buyerID, record.invoiceNumber, record.invoiceID);
      const res = await getInvoicePDF(fileName);
      setPrintInvoiceData(res.data);
      setIsPDFModalOpen(true);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("printInvoiceButton error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const viewSale = (saleID: string) => {
    navigate(`/sale/${saleID}`);
  };

  const editInvoice = (record: any) => {
    navigate(`/invoice/${record.invoiceID}`);
  };

  const getInvoiceExpandedDetails = async (invoiceID: string) => {
    try {
      setLoading(true);
      const currInvoice = invoicesList.find((invoice: any) => invoice.invoiceID === invoiceID);
      const saleInfo = await getSale(currInvoice.saleID);
      const currMaterials: any[] = [];
      for (let materialID of saleInfo.materialIDList) {
        const resMaterial: any = await getMaterial(materialID);
        const materialData = resMaterial.data;
        materialData.key = materialData.materialID;
        const currMetal: any = metals.find((metal: any) => metal.metalID === materialData.metalID);
        materialData.displayName = currMetal.displayName;
        currMaterials.push(materialData);
      }
      const newInvoiceDetails = [...invoiceDetailsTableData];
      const newInvoiceDetailsObject = {
        invoiceID: invoiceID,
        materialsList: currMaterials,
      };
      newInvoiceDetails.push(newInvoiceDetailsObject);
      setInvoiceDetailsTableData([...newInvoiceDetails]);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getInvoiceExpandedDetails error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const formatInvoiceMaterialList = (invoiceDetails: any) => {
    let invoiceMaterialList: any[] = [];
    invoiceDetails.materialsList.forEach((material: any) => {
      const materialIfExists = invoiceMaterialList.find(
        (invoiceMaterial: any) => material.metalID === invoiceMaterial.metalID
      );
      if (materialIfExists) {
        materialIfExists.netWeight = (Number(materialIfExists.netWeight) + Number(material.netWeight)).toFixed(1);
      } else {
        invoiceMaterialList.push({ ...material });
      }
    });
    return [...invoiceMaterialList];
  };

  const displayInvoiceDetails = (invoiceID: string) => {
    const currInvoice = invoicesList.find((invoice: any) => invoice.invoiceID === invoiceID);
    const currInvoiceDetails = invoiceDetailsTableData.find((invoice: any) => invoice.invoiceID === invoiceID);
    if (currInvoiceDetails === undefined || currInvoiceDetails === null) return <></>;
    return (
      <Row justify="center">
        <Col span={16}>
          <Table
            dataSource={formatInvoiceMaterialList(currInvoiceDetails)}
            columns={invoiceDetailsColumns}
            pagination={false}
          />
          <Row style={{ margin: "10px 0" }}>
            <Col span={12}>
              <strong>Payment Method</strong>
              {currInvoice.paymentMethod === "Cash" && <Row>Cash: RM {Number(currInvoice.cashAmount).toFixed(2)}</Row>}
              {currInvoice.paymentMethod === "Online" && (
                <Row>Online: RM {Number(currInvoice.onlineAmount).toFixed(2)}</Row>
              )}
              {currInvoice.paymentMethod === "Cash + Online" && (
                <>
                  <Row>Cash: RM {Number(currInvoice.cashAmount).toFixed(2)}</Row>
                  <Row>Online: RM {Number(currInvoice.onlineAmount).toFixed(2)} </Row>
                </>
              )}
            </Col>
            <Col span={12}>
              <Row justify="end">
                {/* <h4 style={{ fontStyle: "italic", color: "grey" }}>
                  Total Invoice Amount: RM {Number(currInvoice.totalAmount).toFixed(2)}
                </h4> */}
                <h4>
                  <strong>Total Payment Amount: RM {Number(currInvoice.totalAmount).toFixed(2)}</strong>
                </h4>
              </Row>
            </Col>
          </Row>
          {currInvoice.notes && (
            <>
              <Row style={{ margin: "10px 0" }}>
                <strong>Notes</strong>
              </Row>
              <Row>{currInvoice.notes}</Row>
            </>
          )}
        </Col>
      </Row>
    );
  };

  const isTimestampMoreThan2Hours = (timestamp: any) => {
    const createdMilliseconds = new Date(timestamp).getTime();
    const currentTimeMilliseconds = new Date().getTime();
    return currentTimeMilliseconds - createdMilliseconds > 7776000000 ? true : false;
  };

  const openDeleteInvoiceModal = (record: any) => {
    setInvoiceToDelete(record);
    setIsDeleteModalOpen(true);
  };

  const confirmDeleteInvoice = async () => {
    //call api to delete
    setIsDeleteModalOpen(false);
    await deleteInvoice(invoiceToDelete.invoiceID);
    await getInvoices(currentPage, buyersSelectedOptions, dateRangeFilter);
  };

  const deleteInvoice = async (invoiceID: string) => {
    try {
      setLoading(true);
      const res = await deleteInvoiceService(invoiceID);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("deleteInvoice error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const declineDeleteInvoice = () => {
    setIsDeleteModalOpen(false);
  };

  const closePDFModal = () => {
    setIsPDFModalOpen(false);
  };

  const printInvoicePDF = () => {
    printJS({ printable: encodeURI(printInvoiceData), type: "pdf", base64: true });
  };

  const confirmFilterMaterials = async () => {
    setIsFilterModalOpen(false);
    await getInvoices(1, buyersSelectedOptions, dateRangeFilter);
    setIsFilteredData(true);
  };

  const cancelFilterMaterials = () => {
    setIsFilterModalOpen(false);
  };

  const openFilterModal = () => {
    getBuyersFilterOptions();
    setIsFilterModalOpen(true);
  };

  const resetFilters = async () => {
    setBuyersSelectedOptions("");
    setDateRangeFilter([]);
    setDateRangeValue([null, null]);
    await getInvoices(1, "", []);
    setIsFilterModalOpen(false);
    setIsFilteredData(false);
  };

  const updateBuyerFilter = (value: any) => {
    setBuyersSelectedOptions(value);
  };

  const getSelectedBuyersValue = () => {
    if (buyersSelectedOptions === "") return [];
    return buyersSelectedOptions;
  };

  const updateDateRangeFilter = (dateRange: string[]) => {
    setDateRangeValue([dayjs(dateRange[0], "YYYY-MM-DD"), dayjs(dateRange[1], "YYYY-MM-DD")]);
    setDateRangeFilter(dateRange);
  };

  const getBuyersFilterOptions = () => {
    const options: any = [];
    buyers.forEach((buyer: any) => {
      options.push({
        value: buyer.buyerID,
        label:
          buyer.companyName !== "" && buyer.companyName !== undefined
            ? `${buyer.companyName} ( ${buyer.name} )`
            : `${buyer.name}`,
      });
    });
    setBuyersOptions(options);
  };

  return (
    <Layout>
      <Loader loading={loading} />
      <Sidebar collapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />
      <Content>
        <Header toggleSidebar={toggleSidebar} />
        <Row justify="center">
          <Col span={22}>
            <Row justify="start">
              <Col span={12}>
                <h2 className="invoices-title">Invoices</h2>
              </Col>
              <Col span={12}>
                <Row justify="end">
                  <Button
                    type="default"
                    onClick={() => openFilterModal()}
                    icon={<FilterOutlined />}
                    style={{
                      marginTop: "20px",
                      marginRight: "10px",
                      color: isFilteredData ? "white" : "",
                      backgroundColor: isFilteredData ? "#283555" : "",
                    }}
                  ></Button>
                  <Button
                    type="default"
                    onClick={() => {
                      resetFilters();
                    }}
                    icon={<ReloadOutlined />}
                    style={{ marginTop: "20px" }}
                  >
                    Reload Data
                  </Button>
                </Row>
              </Col>
            </Row>
            <Divider style={{ margin: "12px 0" }} />
            <Table
              dataSource={[...invoicesList]}
              columns={invoiceColumns}
              pagination={{
                pageSize: 20,
                total: totalInvoices,
                showSizeChanger: false,
                onChange: (page) => {
                  setCurrentPage(page);
                  getInvoices(page, buyersSelectedOptions, dateRangeFilter);
                },
              }}
              expandedRowRender={(record: any) => displayInvoiceDetails(record.invoiceID)}
              expandIcon={({ expanded, onExpand, record }) =>
                expanded ? (
                  <Button type="default" size="small" onClick={(e) => onExpand(record, e)}>
                    Hide Details
                  </Button>
                ) : (
                  <Button
                    type="default"
                    size="small"
                    onClick={async (e) => {
                      await getInvoiceExpandedDetails(record.invoiceID);
                      onExpand(record, e);
                    }}
                  >
                    Show Details
                  </Button>
                )
              }
            />
          </Col>
        </Row>
        <Copyright />
      </Content>
      <Modal
        title="Delete Invoice"
        open={isDeleteModalOpen}
        okText="Confirm"
        okType="danger"
        onOk={confirmDeleteInvoice}
        onCancel={declineDeleteInvoice}
      >
        <p>
          Are you sure you want to delete this invoice from
          <strong>{invoiceToDelete.buyerName}</strong> on{" "}
          <strong>{new Date(invoiceToDelete.createdTimestamp).toLocaleDateString("en-GB")}</strong>?
        </p>
        <p>This will permanently delete this invoice and this action cannot be undone.</p>
      </Modal>
      <Modal
        title="Invoice PDF"
        style={{ height: "600px" }}
        open={isPDFModalOpen}
        okText="Print"
        onOk={printInvoicePDF}
        onCancel={closePDFModal}
      >
        <iframe
          title="printInvoice"
          id="printInvoice"
          src={`data:application/pdf;base64, ${encodeURI(printInvoiceData)}`}
          height="500px"
          width="100%"
        ></iframe>
      </Modal>
      <Modal
        title="Filter Sales"
        open={isFilterModalOpen}
        cancelButtonProps={{ style: { display: "none" } }}
        okButtonProps={{ style: { display: "none" } }}
        onCancel={cancelFilterMaterials}
      >
        <Row>
          <Col span={24}>
            <Row style={{ marginBottom: "10px" }}>Buyers:</Row>
            <Row style={{ marginBottom: "10px" }}>
              <Select
                showSearch
                mode="multiple"
                allowClear
                style={{ width: "100%" }}
                placeholder="Select buyers"
                value={getSelectedBuyersValue()}
                onChange={updateBuyerFilter}
                options={buyersOptions}
                filterOption={(input: any, option: any) => {
                  return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                }}
              />
            </Row>
            <Row style={{ marginBottom: "10px" }}>Date Range:</Row>
            <Row style={{ marginBottom: "10px" }}>
              <RangePicker
                style={{ width: "100%" }}
                // defaultValue={[null, null]}
                // value={[null, null]}
                value={dateRangeValue}
                onChange={(value, dateString: string[]) => {
                  updateDateRangeFilter(dateString);
                }}
                disabledDate={(current) => {
                  let customDate = moment().add(1, "day").format("YYYY-MM-DD");
                  return current && current > moment(customDate, "YYYY-MM-DD");
                }}
              />
            </Row>
            <Row justify="center" style={{ margin: "30px 0" }}>
              <Button onClick={() => resetFilters()} style={{ marginRight: "20px" }}>
                Reset Filters
              </Button>
              <Button type="primary" onClick={() => confirmFilterMaterials()}>
                Filters Sales
              </Button>
            </Row>
          </Col>
        </Row>
      </Modal>
    </Layout>
  );
};

export default InvoicesPage;
